import { render, staticRenderFns } from "./DashboardModal.vue?vue&type=template&id=7854f9f4&scoped=true&"
import script from "./DashboardModal.vue?vue&type=script&lang=ts&"
export * from "./DashboardModal.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardModal.vue?vue&type=style&index=0&id=7854f9f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7854f9f4",
  null
  
)

export default component.exports